import React, {useLayoutEffect} from 'react'

import ProjectSession from "../../../../../core/model2/project/project-session"
import NavigationMenuItemInputCommon from "../add/menu-item-add-common"
import project_getIconClass from "../../../../../core/model2/project/actions/get-project-icon-class"
import {BUS_APP_LAUNCH, PROJECT_ITEM_VIEW_CLOSE} from "../../../../../core/gd/app-manager/@event";
import {EVENT_BUS_MENU_RENAME} from "../../../sections/const";

type Props = {
    project : ProjectSession
    level?  : number

    onDone  : func
}

// const debug = "NavigationMenuItemProjectRename"
const debug = false

export default function NavigationMenuItemProjectRename(props: Props) {

    useLayoutEffect(() => {
        gd.bus.triggerEvent(EVENT_BUS_MENU_RENAME)                                                  // close all previously rendered NavigationMenuItemProjectRename
        const unsubscribeRename = gd.bus.subscribeNoContext(EVENT_BUS_MENU_RENAME, onItemRename)    // register for close on new NavigationMenuItemProjectRename render

        return () => {
            unsubscribeRename()
        }
    }, [])

    const onItemRename = () => {
        props.onDone()
    }

    const onCommitRename = (value?:string) => {
        const name = _.trim(value)
        debug && console.log(debug, 'onCommitRename', name, value)

        if (name) {
            props.project.name = name
            gd.api.Project.update(props.project.id, {name: value})
        }

        props.onDone()
    }

    return (
        <NavigationMenuItemInputCommon iconClass    = {props.project.iconClass || project_getIconClass(props.project.projectIcon)}
                                       projectIcon  = {props.project.projectIcon}
                                       color        = {props.project.color}
                                       level        = {props.level}
                                       parentId     = {props.project.parentId}
                                       value        = {props.project.name}
                                       onCommit     = {onCommitRename}/>
    )
}
